/* eslint no-undef: 0 */
// import 'babel-polyfill';

// Load Styles
import '../scss/globals.scss';

// Bootstrap dependencies
import '@popperjs/core';
import {
    // Alert,
    // Button,
    // Carousel,
    Collapse,
    Dropdown,
    // Modal,
    // Popover,
    // Scrollspy,
    Tab,
    // Toast,
    // Tooltip
} from 'bootstrap';

// Vendor
import 'slick-carousel/slick/slick.js';
import 'tinynav/dist/tinynav';

// Custom Scripts
import './scripts';
import './main-nav-controller';
import './slider-controller';
